import * as React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';

function EmailClick({ color = colors.actionMinor[500], ...props }) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
            <path
                fill={color}
                d="M2 12v-2h3v2H2Zm3.4 5.55L4 16.1 6.1 14l1.45 1.4-2.15 2.15ZM6.1 8 4 5.9l1.4-1.45L7.55 6.6 6.1 8ZM18 20l-4.75-4.75L12 19 9 9l10 3-3.7 1.3L20 18l-2 2ZM10 6V3h2v3h-2Zm5.9 2-1.45-1.4 2.15-2.15 1.4 1.4L15.9 8Z"
            />
        </svg>
    );
}

export default EmailClick;
